<template>
  <div>
    <div class="auth-fluid">
      <div class="auth-fluid-form-box">
        <div class="d-flex h-100">
          <div class="card-body">

            <div class="page-logo">
              <a href="index.html">
                <span><img src="../../assets/images/logo.png"></span>
              </a>
            </div>


            <router-view></router-view>
            <!-- <footer class="footer footer-alt">
              <p class="text-muted"><b>极客授权系统</b></p>
            </footer> -->

          </div>
        </div>
        <div class="page-menu">
          <div class="menu-item" v-for="item in menu" :key="item.path" :class="$route.path == item.path?'active':''"
            @click="$router.push(item.path)">
            {{item.name}}
          </div>


        </div>

      </div>

      <div class="auth-fluid-right text-center">
        <div class="auth-user-testimonial">
          <h2 class="mb-3">Geek-AUTH</h2>
          <p class="lead">
            多应用授权系统 v1.0
          </p>
          <p>
            客服QQ: <a href="http://wpa.qq.com/msgrd?v=3&uin=3332342231&site=qq&menu=yes">3332342231</a>
          </p>
        </div> <!-- end auth-user-testimonial-->
      </div>
      <!-- end Auth fluid right content -->
    </div>
    <!-- end auth-fluid-->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        menu: [{
          path: "/",
          name: "在线授权"
        }, {
          path: "/down",
          name: "下载源码"
        }, {
          path: "/replace",
          name: "更换授权"
        }, {
          path: "/query",
          name: "查询授权"
        }, ]
      };
    },
    created() {
      console.log(this.$route)
    },
  };
</script>

<style lang="less" scoped>
  @import url("../../assets/css/app.min.css");

  .card-body {
    padding: 0;

    .input-group {
      margin-bottom: 1rem;
    }
  }

  .page-logo {
    text-align: center;
    margin-bottom: 20px;

    img {
      height: 100px;
    }
  }
.h-100{
  margin-bottom: 20px;
}
  .page-menu {
    max-width: 480px;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #ffffff;
    width: 100%;

    .menu-item {
      width: 25%;
      float: left;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      text-align: center;
      cursor: pointer;
      border-top: 1px solid #dee2e6;
      border-left: 0.5px solid #dee2e6;
    }

    .menu-item:hover {
      color: #727cf5;
    }

    .active {
      color: #fff;
      background: #727cf5;
    }
    .active:hover{
      color: #fff;
    }
  }
  @media screen and (max-width: 768px) {
  .page-logo img {
    height: 70px;
  }
 
}
</style>